export type {OverlayScrollbarsComponentRef} from 'overlayscrollbars-react';
export type {ScrollProps} from './scroll.component';
export {Scroll} from './scroll.component';
export {useSyncedScrollContainers} from './use-synced-scroll-containers';
export {useScrollWithExternalScrollbars} from './use-scroll-with-external-scrollbars';
export {ScrollArrows} from './scroll-arrows.component';
export {ScrollArrow} from './scroll-arrow.component';
export {getDefaultOptions} from './getDefaultOptions';
